import React from "react";
import { createCreateContainersAmountCard } from "../boxBreakCardCreators";
import { ScanFlowV2 } from "crossdock/common/flow/ScanFlowV2";

export const CreateContainers: React.FC = () => <ScanFlowV2 onMountCardData={createCreateContainersAmountCard({})} />;
